import { useState, useEffect, useCallback } from 'react';
import { alpha } from '@mui/material/styles';
import { motion } from 'framer-motion';
import {
  Alert,
  Box,
  Button,
  // FormControl,
  Grid,
  // InputLabel,
  // MenuItem,
  // Select,
  SelectChangeEvent,
  Snackbar,
  Typography,
  // Divider,
} from '@mui/material';
import {
  PersonAdd,
  Send,
  PostAdd,
  // TaskAlt,
  // CalendarToday,
  // TrendingUp,
  Email,
  CheckCircleOutline,
  Twitter,
  Link,
  Message,
  // EditNote,
  // Refresh,
  Undo,
} from '@mui/icons-material';
import Cookies from 'js-cookie';
import { Dayjs } from 'dayjs';
import AppVerifiedUsers from '../components/app/AppVerifiedUsers';
import FollowUpCard from '../components/app/FollowUpCard';
// import UserTimeInfo from '../components/app/UserTimeInfo';
import backendService from '../components/backendservices/BackendService';
// import BarGraph from '../components/charts/BarGraph';
// import LinkedInStatsChart from '../components/charts/LinkedInStatsChart';
import AnalyticsLineChart from '../components/charts/AnalyticsLineChart';
import LinkedInStatsForm from '../components/LinkedInStatsForm';
// import LinkedInWeeklyReport from '../components/LinkedInWeeklyReport';
import AnalyticsForm from '../components/AnalyticsForm';
import Loader from '../components/Loader';
import Page from '../components/Page';
import { capitalizeFirstLetter } from '../utils/textUtils';
import PendingTasksList from '../components/app/PendingTasksList';
import ContentTrackingService from '../components/backendservices/ContentTrackingService';
import { ContentTask } from '../types/ContentTracking';

import {
  // DailyStat,
  // LinkedInWeekData,
  PreviousWeekCheckResponse,
  StatsData,
  User,
  // UserStatsData,
} from '../types/Dashboard';

const initialStatsData: StatsData = {
  totalUsers: 0,
  connectionSend: 0,
  totalContacted: 0,
  contactedPercentage: 0,
  uncontactedUsers: 0,
  followUp1Remaining: 0,
  followUp2Remaining: 0,
  followUp3Remaining: 0,
  followup1Completed: 0,
  followup2Completed: 0,
  followup3Completed: 0,
  totalFollowUps: 0,
  totalActiveFollowUps: 0,
};

// const initialUserStatsData: UserStatsData = {
//   dailyTotals: [],
//   userDailyStats: [],
//   period: 'week',
// };

export default function DashboardApp() {
  const [statsData, setStatsData] = useState<StatsData>(initialStatsData);
  // const [userStatsData, setUserStatsData] = useState<UserStatsData>(initialUserStatsData);
  const adminName = Cookies.get('role');
  const username = Cookies.get('username') || '';
  const isSuperAdmin = adminName === 'superadmin';
  const [loading, setLoading] = useState(true);
  // const [period] = useState('week');
  const [users, setUsers] = useState<User[]>([]);
  // For non-superadmin users, automatically set their username
  // const [selectedUser, setSelectedUser] = useState<string>('');

  // LinkedIn Stats State
  // const [linkedInStats, setLinkedInStats] = useState<LinkedInWeekData[]>([]);
  // const [selectedMonth, setSelectedMonth] = useState('All');
  const [showLinkedInForm, setShowLinkedInForm] = useState(false);
  const [previousWeekData, setPreviousWeekData] = useState<{
    weekStartDate: string;
    weekEndDate: string;
  } | null>(null);
  const [notification, setNotification] = useState<{
    open: boolean;
    message: string;
    severity: 'success' | 'info' | 'warning' | 'error';
  }>({
    open: false,
    message: '',
    severity: 'info',
  });

  // Analytics State
  const [showAnalyticsForm, setShowAnalyticsForm] = useState(false);
  const [analyticsData, setAnalyticsData] = useState<{
    connectionsSent: number;
    emailsSent: number;
    connectionsAccepted: number;
    twitterDMsSent: number;
    telegramDMsSent: number;
    leadsGenerated: number;
    existingConnections: number;
    invertedConnections: number;
  } | null>(null);
  const [analyticsHistoryData, setAnalyticsHistoryData] = useState<
    Array<{
      date?: string;
      _id?: string;
      connectionsSent?: number;
      emailsSent?: number;
      connectionsAccepted?: number;
      twitterDMsSent?: number;
      telegramDMsSent?: number;
      leadsGenerated?: number;
      existingConnections?: number;
      invertedConnections?: number;
    }>
  >([]);
  const [analyticsPeriod, setAnalyticsPeriod] = useState<string>('30'); // Default: last 30 days
  const [analyticsGroupBy, setAnalyticsGroupBy] = useState<string>('day');
  const [analyticsStartDate, setAnalyticsStartDate] = useState<Dayjs | null>(null);
  const [analyticsEndDate, setAnalyticsEndDate] = useState<Dayjs | null>(null);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const [submittedDates, setSubmittedDates] = useState<Record<string, boolean>>({});
  // Selected user for analytics (for superadmin to filter analytics by user)
  const [selectedAnalyticsUser, setSelectedAnalyticsUser] = useState<string>('all');
  const [selectedMetric, setSelectedMetric] = useState<string>('connectionsSent');

  // Pending Tasks State
  const [tasks, setTasks] = useState<ContentTask[]>([]);
  const [tasksLoading, setTasksLoading] = useState(false);

  // Fetch basic stats from api/v1/user/stats
  const getStats = useCallback(async () => {
    try {
      const response = await backendService.Get(`${process.env.REACT_APP_BASE_URL}/user/stats`);
      if (response.status === 200) {
        setStatsData(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  }, []);

  const getTasks = useCallback(async () => {
    setTasksLoading(true);
    try {
      const response = await ContentTrackingService.getAllTasks();
      if (response.status) {
        setTasks(response.data);
      }
    } catch (error) {
      console.error('Error fetching tasks:', error);
    } finally {
      setTasksLoading(false);
    }
  }, []);

  // Fetch user stats from api/v1/user/userStats
  // const getUserStats = useCallback(async () => {
  //   try {
  //     const response = await backendService.Get(
  //       `${process.env.REACT_APP_BASE_URL}/user/userStats?period=${period}${selectedUser ? `&username=${selectedUser}` : ''}`
  //     );
  //     if (response.status === 200) {
  //       setUserStatsData(response.data.data);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching user statistics:', error);
  //   }
  // }, [selectedUser, period]);

  const getUsers = async () => {
    try {
      const response = await backendService.Get(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/users?page=1`
      );
      if (response.status === 200) {
        setUsers(response.data);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  // const handlePeriodChange = (newPeriod: string) => {
  //   setPeriod(newPeriod);
  // };

  // const handleUserChange = (event: SelectChangeEvent) => {
  //   setSelectedUser(event.target.value);
  // };

  const handleAnalyticsUserChange = (event: SelectChangeEvent) => {
    setSelectedAnalyticsUser(event.target.value);
  };

  // Fetch LinkedIn stats
  // const getLinkedInStats = useCallback(async (showNotification = false) => {
  //   try {
  //     const response = await backendService.Get(
  //       `${process.env.REACT_APP_BASE_URL}/linkedin-connection-stats/weekly`
  //     );
  //     if (response.status === 200) {
  //       setLinkedInStats(response.data.data);
  //     }
  //   } catch (error: any) {
  //     console.error('Error fetching LinkedIn stats:', error);
  //     if (error.response?.status === 429 && showNotification) {
  //       setNotification({
  //         open: true,
  //         message: error.response?.data?.message || 'Too many requests. Please try again later.',
  //         severity: 'error',
  //       });
  //     }
  //   }
  // }, []);

  // Check if previous week needs filling
  const checkPreviousWeek = useCallback(async () => {
    try {
      const response = await backendService.Get(
        `${process.env.REACT_APP_BASE_URL}/linkedin-connection-stats/check-previous-week`
      );
      if (response.status === 200) {
        const data: PreviousWeekCheckResponse = response.data;
        if (data.data.needsFilling) {
          setPreviousWeekData({
            weekStartDate: data.data.previousWeekStart.split('T')[0],
            weekEndDate: data.data.previousWeekEnd.split('T')[0],
          });
          setShowLinkedInForm(true);
        } else {
          // Show notification that data is already filled
          setNotification({
            open: true,
            message: 'Previous week data is already filled!',
            severity: 'info',
          });
        }
      }
    } catch (error) {
      console.error('Error checking previous week:', error);
      setNotification({
        open: true,
        message: 'Error checking previous week data',
        severity: 'error',
      });
    }
  }, []);

  // Check if it's Friday and user is admin
  const checkFridayPopup = useCallback(() => {
    const today = new Date();
    const isFriday = today.getDay() === 5; // 5 = Friday
    const isAdmin = adminName === 'admin';

    if (isFriday && isAdmin) {
      // Check if previous week needs filling
      checkPreviousWeek();
    }
  }, [adminName, checkPreviousWeek]);

  // Check for missing previous week data (for admin on any day)
  const checkMissingData = useCallback(() => {
    const isAdmin = adminName === 'admin';
    if (isAdmin) {
      checkPreviousWeek();
    }
  }, [adminName, checkPreviousWeek]);

  // Manual trigger for filling LinkedIn data (for admin)
  // const handleManualFillLinkedIn = useCallback(() => {
  //   if (adminName === 'admin') {
  //     checkPreviousWeek();
  //   }
  // }, [adminName, checkPreviousWeek]);

  // Manual trigger for filling current week LinkedIn data (for admin)
  // const handleFillCurrentWeek = useCallback(() => {
  //   if (adminName === 'admin') {
  //     setShowLinkedInForm(true);
  //     setPreviousWeekData(null); // This will trigger the current week tab
  //   }
  // }, [adminName]);

  // Fetch analytics data with filters
  const getAnalyticsData = useCallback(async () => {
    setAnalyticsLoading(true);
    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;
      let url = `${baseUrl}/analytics`;

      // Build query parameters
      const params = new URLSearchParams();

      // If date range is specified, use it
      if (analyticsStartDate && analyticsEndDate) {
        params.append('startDate', analyticsStartDate.format('YYYY-MM-DD'));
        params.append('endDate', analyticsEndDate.format('YYYY-MM-DD'));
      } else if (analyticsPeriod === 'all') {
        params.append('period', 'all');
      } else {
        params.append('period', analyticsPeriod);
      }

      // Add groupBy if specified
      if (analyticsGroupBy && analyticsGroupBy !== 'day') {
        params.append('groupBy', analyticsGroupBy);
      }

      // Add username filter for superadmin
      if (isSuperAdmin) {
        params.append('username', selectedAnalyticsUser);
      }

      // Add role filter if needed (for superadmin to filter by role)
      // const userRole = Cookies.get('role');
      // if (userRole === 'superadmin' && selectedRole) {
      //   params.append('role', selectedRole);
      // }

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      console.log('Fetching analytics from:', url);
      const response = await backendService.Get(url);

      if (response.status === 200) {
        console.log('Analytics API Response:', response.data);

        // Handle the response structure: { success: true, data: { totalMetrics, weeklyData, submittedDates, ... } }
        const responseData = response.data;

        // Store submittedDates if available at top level or in data
        if (responseData.submittedDates) {
          setSubmittedDates(responseData.submittedDates);
        }

        // Collect raw data from various possible response structures
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let rawHistoryData: any[] = [];

        if (responseData.success && responseData.data) {
          const analyticsResponse = responseData.data;
          if (analyticsResponse.weeklyData && Array.isArray(analyticsResponse.weeklyData)) {
            rawHistoryData = analyticsResponse.weeklyData;
          } else if (analyticsResponse.dailyData && Array.isArray(analyticsResponse.dailyData)) {
            rawHistoryData = analyticsResponse.dailyData;
          } else if (Array.isArray(analyticsResponse.data)) {
            rawHistoryData = analyticsResponse.data;
          }
        } else if (Array.isArray(responseData.data)) {
          rawHistoryData = responseData.data;
        } else if (responseData.data && typeof responseData.data === 'object') {
          rawHistoryData = [responseData.data];
        }

        // Filter for 'all' username if present (backend pre-aggregation)
        // This prevents double-counting if the backend returns both individual users and an 'all' summary
        const allUserEntries = rawHistoryData.filter((entry) => entry.username === 'all');
        if (allUserEntries.length > 0) {
          console.log('Found pre-aggregated "all" user entries, using these for display.');
          rawHistoryData = allUserEntries;
        }

        // Aggregate data by date
        const aggregatedHistory = rawHistoryData
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .reduce((acc: any[], entry: any) => {
            const dateStr = entry.date || entry._id;
            if (!dateStr) return acc;

            const dateKey = new Date(dateStr).toISOString().split('T')[0];
            const existingIndex = acc.findIndex(
              (item) => new Date(item.date || item._id).toISOString().split('T')[0] === dateKey
            );

            if (existingIndex >= 0) {
              acc[existingIndex].connectionsSent =
                (acc[existingIndex].connectionsSent || 0) + (entry.connectionsSent || 0);
              acc[existingIndex].emailsSent =
                (acc[existingIndex].emailsSent || 0) + (entry.emailsSent || 0);
              acc[existingIndex].connectionsAccepted =
                (acc[existingIndex].connectionsAccepted || 0) + (entry.connectionsAccepted || 0);
              acc[existingIndex].twitterDMsSent =
                (acc[existingIndex].twitterDMsSent || 0) + (entry.twitterDMsSent || 0);
              acc[existingIndex].telegramDMsSent =
                (acc[existingIndex].telegramDMsSent || 0) + (entry.telegramDMsSent || 0);
              acc[existingIndex].leadsGenerated =
                (acc[existingIndex].leadsGenerated || 0) + (entry.leadsGenerated || 0);
              acc[existingIndex].existingConnections =
                (acc[existingIndex].existingConnections || 0) + (entry.existingConnections || 0);
              acc[existingIndex].invertedConnections =
                (acc[existingIndex].invertedConnections || 0) + (entry.invertedConnections || 0);
            } else {
              acc.push({ ...entry }); // Create a copy of the entry
            }
            return acc;
          }, [])
          .sort(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (a: any, b: any) =>
              new Date(a.date || a._id).getTime() - new Date(b.date || b._id).getTime()
          );

        console.log('Setting aggregated history data:', aggregatedHistory);
        setAnalyticsHistoryData(aggregatedHistory);

        // Handle Total Metrics for Cards
        console.log('Total Metrics Check:', responseData.data?.totalMetrics);

        // Use totalMetrics from API if available (and it looks valid)
        if (
          responseData.data?.totalMetrics &&
          Object.keys(responseData.data.totalMetrics).length > 0
        ) {
          const metrics = {
            connectionsSent: responseData.data.totalMetrics.connectionsSent || 0,
            emailsSent: responseData.data.totalMetrics.emailsSent || 0,
            connectionsAccepted: responseData.data.totalMetrics.connectionsAccepted || 0,
            twitterDMsSent: responseData.data.totalMetrics.twitterDMsSent || 0,
            telegramDMsSent: responseData.data.totalMetrics.telegramDMsSent || 0,
            leadsGenerated: responseData.data.totalMetrics.leadsGenerated || 0,
            existingConnections: responseData.data.totalMetrics.existingConnections || 0,
            invertedConnections: responseData.data.totalMetrics.invertedConnections || 0,
          };
          console.log('Setting analytics data (cards) from totalMetrics:', metrics);
          setAnalyticsData(metrics);
        } else {
          // Fallback: Calculate from aggregated history (Today or Latest)
          const today = new Date().toISOString().split('T')[0];
          const todayEntry = aggregatedHistory.find(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (entry: any) => new Date(entry.date || entry._id).toISOString().split('T')[0] === today
          );

          if (todayEntry) {
            setAnalyticsData({
              connectionsSent: todayEntry.connectionsSent || 0,
              emailsSent: todayEntry.emailsSent || 0,
              connectionsAccepted: todayEntry.connectionsAccepted || 0,
              twitterDMsSent: todayEntry.twitterDMsSent || 0,
              telegramDMsSent: todayEntry.telegramDMsSent || 0,
              leadsGenerated: todayEntry.leadsGenerated || 0,
              existingConnections: todayEntry.existingConnections || 0,
              invertedConnections: todayEntry.invertedConnections || 0,
            });
            console.log('Setting analytics data (cards) from Today:', todayEntry);
          } else if (aggregatedHistory.length > 0) {
            const latest = aggregatedHistory[aggregatedHistory.length - 1];
            setAnalyticsData({
              connectionsSent: latest.connectionsSent || 0,
              emailsSent: latest.emailsSent || 0,
              connectionsAccepted: latest.connectionsAccepted || 0,
              twitterDMsSent: latest.twitterDMsSent || 0,
              telegramDMsSent: latest.telegramDMsSent || 0,
              leadsGenerated: latest.leadsGenerated || 0,
              existingConnections: latest.existingConnections || 0,
              invertedConnections: latest.invertedConnections || 0,
            });
            console.log('Setting analytics data (cards) from Latest:', latest);
          } else {
            setAnalyticsData(null);
          }
        }
      }
    } catch (error) {
      console.error('Error fetching analytics data:', error);
      setAnalyticsData(null);
      setAnalyticsHistoryData([]);
    } finally {
      setAnalyticsLoading(false);
    }
  }, [
    analyticsPeriod,
    analyticsGroupBy,
    analyticsStartDate,
    analyticsEndDate,
    isSuperAdmin,
    selectedAnalyticsUser,
  ]);

  // Handle analytics form success
  const handleAnalyticsFormSuccess = useCallback(() => {
    getAnalyticsData(); // Refresh analytics data
    setShowAnalyticsForm(false); // Close the form
    setNotification({
      open: true,
      message: 'Analytics data saved successfully!',
      severity: 'success',
    });
  }, [getAnalyticsData]);

  // Track if this is the initial mount
  const [isInitialMount, setIsInitialMount] = useState(true);

  // Auto-refetch analytics when filters change (but not on initial load)
  useEffect(() => {
    if (isInitialMount) {
      setIsInitialMount(false);
      return;
    }

    if (adminName === 'admin' || adminName === 'sales' || adminName === 'superadmin') {
      // Small delay to avoid too many requests
      // Don't show form when filters change, only fetch data
      const timer = setTimeout(() => {
        getAnalyticsData();
      }, 500);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [
    analyticsPeriod,
    analyticsGroupBy,
    analyticsStartDate,
    analyticsEndDate,
    adminName,
    getAnalyticsData,
    isInitialMount,
    selectedAnalyticsUser,
  ]);

  // Initial load - fetch basic stats and setup
  useEffect(() => {
    const initializeData = async () => {
      setLoading(true);
      try {
        // Always fetch basic stats on initial load
        await getStats();

        // Fetch tasks for all users (filtered later)
        await getTasks();

        // Set selectedUser based on role
        // For non-superadmin users, automatically set their username
        // if (!isSuperAdmin && username) {
        //   setSelectedUser(username);
        // }

        // Get users list based on role
        if (adminName === 'superadmin') {
          await getUsers();
          // await getLinkedInStats(); // Fetch LinkedIn stats for superadmin
        } else if (adminName === 'admin') {
          await getUsers();
          // await getLinkedInStats(); // Fetch LinkedIn stats for admin
          // checkFridayPopup(); // Check for Friday popup
          // Also check for missing data on any day
          // setTimeout(() => {
          //   checkMissingData();
          // }, 2000); // Delay to avoid showing popup immediately
        }

        // Fetch analytics data for admin, sales, and superadmin
        if (adminName === 'admin' || adminName === 'sales' || adminName === 'superadmin') {
          // Fetch analytics data (form will only show on button click for admin/sales)
          getAnalyticsData();
        }
      } catch (error) {
        console.error('Error initializing data:', error);
      } finally {
        setLoading(false);
      }
    };

    initializeData();
  }, [
    adminName,
    isSuperAdmin,
    username,
    getStats,
    getTasks,
    // getLinkedInStats,
    checkFridayPopup,
    checkMissingData,
    // getAnalyticsData is excluded to prevent full-page reloads on filter changes.
    // getAnalyticsData is already handled by a separate auto-fetch effect.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ]);

  // Separate effect for user stats - only reload when period or selectedUser changes
  // useEffect(() => {
  //   // For superadmin, they can filter by user. For others, show their own stats
  //   getUserStats();
  // }, [period, selectedUser, getUserStats]);

  const handleLinkedInFormSuccess = () => {
    console.log('LinkedIn form success callback triggered');
    // getLinkedInStats(); // Refresh LinkedIn stats
    setShowLinkedInForm(false);
    setPreviousWeekData(null);

    // Show success notification
    setNotification({
      open: true,
      message: 'LinkedIn data saved successfully!',
      severity: 'success',
    });
  };

  // const handleMonthChange = (event: SelectChangeEvent) => {
  //   setSelectedMonth(event.target.value);
  // };

  const handleNotificationClose = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };
  console.log('adminName', adminName);
  console.log('users', users);

  const welcomeVariants: any = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: [0.16, 1, 0.3, 1],
        staggerChildren: 0.15,
      },
    },
  };

  return (
    <Page title='Dashboard'>
      <Box
        sx={{
          p: { xs: 2, md: 3 },
          minHeight: '100vh',
          width: '100%',
          borderRadius: 4,
          background: 'transparent',
          position: 'relative',
        }}
      >
        {/* Header Section */}
        <Box
          component={motion.div}
          {...({
            initial: 'hidden',
            animate: 'visible',
            variants: welcomeVariants,
          } as any)}
          sx={{
            mb: 6,
            px: 1,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'flex-start', md: 'center' },
            justifyContent: 'space-between',
            gap: 4,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
              <Typography
                variant='h3'
                component={motion.h3}
                animate={{
                  backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
                }}
                transition={{
                  duration: 10,
                  repeat: Infinity,
                  ease: 'linear',
                }}
                sx={{
                  fontWeight: 900,
                  fontFamily: 'Lato, sans-serif',
                  fontSize: { xs: '2.5rem', md: '3.5rem' },
                  background: 'linear-gradient(90deg, #fff, #a2a8ff, #fff, #8b93ff, #fff)',
                  backgroundSize: '200% auto',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  lineHeight: 1.2,
                  filter: 'drop-shadow(0 0 30px rgba(139, 147, 255, 0.15))',
                  willChange: 'background-position',
                  cursor: 'default',
                  letterSpacing: '-0.5px',
                }}
              >
                Welcome, {capitalizeFirstLetter(Cookies.get('username') || 'User')}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box
                sx={{
                  width: 14,
                  height: 2,
                  bgcolor: 'rgba(139, 147, 255, 0.6)',
                  borderRadius: 4,
                  mt: 0.5,
                }}
              />
              <Typography
                sx={{
                  color: 'rgba(255, 255, 255, 0.45)',
                  fontSize: '1.05rem',
                  fontWeight: 500,
                  fontFamily: 'Lato, sans-serif',
                  letterSpacing: '0.3px',
                }}
              >
                Here&apos;s your dashboard overview and key metrics
              </Typography>
            </Box>
          </Box>

          {/* Refresh LinkedIn stats button for superadmin */}
          {/* {adminName === 'superadmin' && (
            <Button
              variant='outlined'
              onClick={() => getLinkedInStats(true)}
              startIcon={<Refresh />}
              sx={{
                borderColor: 'rgba(139, 147, 255, 0.3)',
                color: '#8b93ff',
                px: 3.5,
                py: 1.5,
                borderRadius: '16px',
                textTransform: 'uppercase',
                fontSize: '0.8rem',
                letterSpacing: '1.5px',
                fontWeight: 800,
                background: 'rgba(139, 147, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                '&:hover': {
                  borderColor: '#8b93ff',
                  background: 'rgba(139, 147, 255, 0.1)',
                  transform: 'translateY(-3px)',
                  boxShadow: '0 12px 30px rgba(139, 147, 255, 0.2)',
                  '& .MuiButton-startIcon': {
                    transform: 'rotate(180deg)',
                  },
                },
                '& .MuiButton-startIcon': {
                  transition: 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
                },
              }}
            >
              Refresh LinkedIn Stats
            </Button>
          )} */}
        </Box>

        {loading ? (
          <Loader />
        ) : (
          <>
            {/* SECTION 1: Key Performance Metrics & Follow-up Management */}
            <Box sx={{ width: '100%', p: 1, mx: 'auto', mb: 8 }}>
              <Grid container spacing={6}>
                {/* Metrics Section */}
                <Grid item xs={12} lg={8}>
                  <Grid container spacing={0}>
                    {/* Key Performance Metrics */}
                    <Grid item xs={12} lg={12}>
                      <Box
                        className='metric-group'
                        sx={{ mb: 4.5 }}
                        component={motion.div}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                      >
                        <Box sx={{ mb: 3.2, display: 'flex', alignItems: 'center', gap: 1.8 }}>
                          <Box
                            sx={{
                              width: 4,
                              height: 18,
                              bgcolor: '#556ee6',
                              borderRadius: 4,
                              boxShadow: '0 0 10px rgba(85, 110, 230, 0.4)',
                            }}
                          />
                          <Typography
                            sx={{
                              fontWeight: 900,
                              color: 'rgba(255,255,255,0.9)',
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '2.5px',
                              fontFamily: 'Lato, sans-serif',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Key Performance Metrics
                          </Typography>
                          <Box
                            sx={{
                              flex: 1,
                              height: '1px',
                              background:
                                'linear-gradient(to right, rgba(255,255,255,0.1), transparent)',
                              ml: 2,
                            }}
                          />
                        </Box>

                        <Grid container spacing={2.5}>
                          <Grid item xs={3}>
                            <AppVerifiedUsers
                              name='Total Contacts'
                              count={statsData.totalUsers}
                              color='#556ee6'
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <AppVerifiedUsers
                              name='Connections'
                              count={statsData.connectionSend}
                              color='#34c38f'
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <AppVerifiedUsers
                              name='Total Contacted'
                              count={statsData.totalContacted}
                              color='#f1b44c'
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <AppVerifiedUsers
                              name='Uncontacted'
                              count={statsData.uncontactedUsers}
                              color='#f46a6a'
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>

                    {/* Follow-up Performance */}
                    <Grid item xs={12} lg={12}>
                      <Box
                        className='metric-group'
                        component={motion.div}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                      >
                        <Box sx={{ mb: 3.2, display: 'flex', alignItems: 'center', gap: 1.8 }}>
                          <Box
                            sx={{
                              width: 4,
                              height: 18,
                              bgcolor: '#34c38f',
                              borderRadius: 4,
                              boxShadow: '0 0 10px rgba(52, 195, 143, 0.4)',
                            }}
                          />
                          <Typography
                            sx={{
                              fontWeight: 900,
                              color: 'rgba(255,255,255,0.9)',
                              fontSize: '0.75rem',
                              textTransform: 'uppercase',
                              letterSpacing: '2.5px',
                              fontFamily: 'Lato, sans-serif',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Follow-up Performance
                          </Typography>
                          <Box
                            sx={{
                              flex: 1,
                              height: '1px',
                              background:
                                'linear-gradient(to right, rgba(255,255,255,0.1), transparent)',
                              ml: 2,
                            }}
                          />
                        </Box>

                        <Grid container spacing={2}>
                          <Grid item xs={3}>
                            <FollowUpCard
                              title='1st Follow Up'
                              remaining={statsData.followUp1Remaining}
                              completed={statsData.followup1Completed}
                              icon='schedule'
                              color='#556ee6'
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <FollowUpCard
                              title='2nd Follow Up'
                              remaining={statsData.followUp2Remaining}
                              completed={statsData.followup2Completed}
                              icon='schedule'
                              color='#34c38f'
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <FollowUpCard
                              title='3rd Follow Up'
                              remaining={statsData.followUp3Remaining}
                              completed={statsData.followup3Completed}
                              icon='schedule'
                              color='#f1b44c'
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <FollowUpCard
                              title='Active'
                              remaining={statsData.totalActiveFollowUps}
                              completed={statsData.totalFollowUps}
                              icon='play'
                              leftLabel='Active'
                              rightLabel='Total'
                              color='#50a5f1'
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Right Side: Today's Agenda (Visible for matching users) */}
                <Grid item xs={12} lg={4}>
                  <Box
                    sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                    component={motion.div}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.3 }}
                  >
                    <PendingTasksList
                      tasks={tasks}
                      users={users}
                      loading={tasksLoading}
                      currentUserRole={adminName || ''}
                      currentUsername={username}
                      selectedUserFromDashboard={isSuperAdmin ? 'Kumar' : undefined}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            {/* SECTION 0: Daily Analytics Metrics (Admin/Sales/Superadmin) */}
            {(adminName === 'admin' || adminName === 'sales' || adminName === 'superadmin') && (
              <Box sx={{ width: '100%', p: 1, mt: 4, mb: 4, borderRadius: 3 }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 3,
                  }}
                >
                  <Typography
                    variant='h4'
                    sx={{
                      fontWeight: 800,
                      color: '#fff',
                      textAlign: 'left',
                      letterSpacing: 1,
                      position: 'relative',
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: -10,
                        left: 0,
                        width: 40,
                        height: 3,
                        background: '#4CAF50',
                        borderRadius: 2,
                      },
                    }}
                  >
                    Analytics Metrics
                  </Typography>
                  {/* Only show Submit Analytics button for admin and sales, not for superadmin */}
                  {(adminName === 'admin' || adminName === 'sales') && (
                    <Button
                      variant='outlined'
                      onClick={() => {
                        // Check if today's date is already submitted
                        const today = new Date().toISOString().split('T')[0];
                        if (submittedDates[today] === true) {
                          const userName = capitalizeFirstLetter(username || 'User');
                          setNotification({
                            open: true,
                            message: `Hello ${userName}, you have already submitted your analytics entry for today. Please submit again tomorrow.`,
                            severity: 'warning',
                          });
                          return;
                        }
                        setShowAnalyticsForm(true);
                      }}
                      startIcon={<PostAdd />}
                      sx={{
                        borderColor: 'rgba(104, 113, 209, 0.4)',
                        color: '#a0a7ff',
                        px: 3.5,
                        py: 1.2,
                        borderRadius: '16px',
                        textTransform: 'uppercase',
                        fontSize: '0.75rem',
                        letterSpacing: '1.5px',
                        fontWeight: 800,
                        background: 'rgba(104, 113, 209, 0.08)',
                        backdropFilter: 'blur(10px)',
                        transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                        '&:hover': {
                          borderColor: '#6871d1',
                          background: 'rgba(104, 113, 209, 0.15)',
                          transform: 'translateY(-3px)',
                          boxShadow: '0 12px 30px rgba(104, 113, 209, 0.2)',
                          '& .MuiButton-startIcon': {
                            transform: 'scale(1.1)',
                          },
                        },
                        '& .MuiButton-startIcon': {
                          transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                        },
                      }}
                    >
                      Submit Analytics
                    </Button>
                  )}
                </Box>

                <Box
                  component={motion.div}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  sx={{
                    display: 'flex',
                    mb: 5,
                    overflowX: 'auto',
                    scrollbarWidth: 'none',
                    '&::-webkit-scrollbar': { display: 'none' },
                    gap: 1.5, // Space between items instead of borders
                    p: 0.5,
                  }}
                >
                  {[
                    {
                      key: 'connectionsSent',
                      label: 'Connections Sent',
                      color: '#6871d1',
                      icon: <Send />,
                    },
                    {
                      key: 'emailsSent',
                      label: 'Emails Sent',
                      color: '#2196F3',
                      icon: <Email />,
                    },
                    {
                      key: 'connectionsAccepted',
                      label: 'Connections Accepted',
                      color: '#4CAF50',
                      icon: <CheckCircleOutline />,
                    },
                    {
                      key: 'twitterDMsSent',
                      label: 'Twitter DMs',
                      color: '#1DA1F2',
                      icon: <Twitter />,
                    },
                    {
                      key: 'telegramDMsSent',
                      label: 'Telegram DMs',
                      color: '#6871d1',
                      icon: <Message />,
                    },
                    {
                      key: 'leadsGenerated',
                      label: 'Leads Generated',
                      color: '#FF9800',
                      icon: <PersonAdd />,
                    },
                    {
                      key: 'existingConnections',
                      label: 'Existing Connections',
                      color: '#9C27B0',
                      icon: <Link />,
                    },
                    {
                      key: 'invertedConnections',
                      label: 'Inverted Connections',
                      color: '#06d6a0',
                      icon: <Undo />,
                    },
                  ].map((config) => {
                    const isSelected = selectedMetric === config.key;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const value = analyticsData ? (analyticsData as any)[config.key] || 0 : 0;

                    return (
                      <Box
                        key={config.key}
                        onClick={() => setSelectedMetric(config.key)}
                        component={motion.div}
                        whileHover={{ y: -2 }}
                        whileTap={{ scale: 0.98 }}
                        sx={{
                          flex: '1 1 auto',
                          minWidth: { xs: 180, lg: 200 },
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.7,
                          p: '16px 20px',
                          cursor: 'pointer',
                          position: 'relative',
                          transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                          borderRadius: '16px',
                          background: isSelected
                            ? `linear-gradient(135deg, ${alpha(config.color, 0.15)}, ${alpha(config.color, 0.05)})`
                            : 'rgba(255, 255, 255, 0.02)',
                          backdropFilter: 'blur(10px)',
                          border: `1px solid ${isSelected ? alpha(config.color, 0.3) : 'rgba(255, 255, 255, 0.04)'}`,
                          boxShadow: isSelected
                            ? `0 8px 30px ${alpha(config.color, 0.15)}, inset 0 0 20px ${alpha(config.color, 0.05)}`
                            : 'none',

                          '&:hover': {
                            background: isSelected
                              ? `linear-gradient(135deg, ${alpha(config.color, 0.2)}, ${alpha(config.color, 0.08)})`
                              : 'rgba(255, 255, 255, 0.04)',
                            borderColor: isSelected
                              ? alpha(config.color, 0.5)
                              : 'rgba(255, 255, 255, 0.1)',
                            '& .icon-box': {
                              transform: 'scale(1.1)',
                              background: 'transparent',
                              color: isSelected ? '#fff' : config.color,
                            },
                          },
                        }}
                      >
                        <Box
                          className='icon-box'
                          sx={{
                            width: 44,
                            height: 44,
                            borderRadius: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'transparent',
                            color: isSelected ? '#fff' : config.color,
                            transition: 'all 0.4s ease',
                            boxShadow: 'none',
                            fontSize: '1.5rem', // Icons will inherit this size efficiently
                            '& svg': {
                              display: 'block', // Prevents line-height issues
                            },
                          }}
                        >
                          {config.icon}
                        </Box>

                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 0.1,
                            flex: 1,
                            minWidth: 0,
                          }}
                        >
                          <Typography
                            className='stat-value'
                            sx={{
                              color: '#fff',
                              fontWeight: 900,
                              fontSize: '1.5rem', // Larger for emphasis
                              lineHeight: 1,
                              fontFamily: 'Lato, sans-serif',
                              letterSpacing: '-0.5px',
                              opacity: isSelected ? 1 : 0.8,
                            }}
                          >
                            {typeof value === 'number' ? value.toLocaleString() : value}
                          </Typography>
                          <Typography
                            sx={{
                              color: isSelected
                                ? alpha(config.color, 0.9)
                                : 'rgba(255, 255, 255, 0.4)',
                              fontWeight: 700,
                              fontSize: '0.65rem',
                              textTransform: 'uppercase',
                              letterSpacing: '1px',
                              fontFamily: 'Lato, sans-serif',
                              whiteSpace: 'normal',
                              lineHeight: 1.2,
                              transition: 'color 0.3s ease',
                            }}
                          >
                            {config.label}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>

                <AnalyticsLineChart
                  historyData={analyticsHistoryData}
                  period={analyticsPeriod}
                  groupBy={analyticsGroupBy}
                  startDate={analyticsStartDate}
                  endDate={analyticsEndDate}
                  onPeriodChange={(period) => {
                    setAnalyticsPeriod(period);
                    setAnalyticsStartDate(null);
                    setAnalyticsEndDate(null);
                  }}
                  onGroupByChange={setAnalyticsGroupBy}
                  onApplyFilters={getAnalyticsData}
                  loading={analyticsLoading}
                  selectedMetric={selectedMetric}
                  onMetricChange={setSelectedMetric}
                  isSuperAdmin={isSuperAdmin}
                  users={users}
                  selectedUser={selectedAnalyticsUser}
                  onUserChange={handleAnalyticsUserChange}
                />
              </Box>
            )}

            {/* SECTION 2: LinkedIn Analytics */}
            {/* {adminName === 'superadmin' &&
              (() => {
                // Calculate available months from linkedInStats
                const availableMonths = Array.from(
                  new Set(
                    linkedInStats.map((week) => {
                      const date = new Date(week.weekStartDate);
                      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
                    })
                  )
                );

                return (
                  <Box sx={{ width: '100%', p: 1, mb: 4, borderRadius: 3 }}>
       
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        mb: 1,
                        px: { xs: 1, sm: 2 },
                      }}
                    >
                      <Typography
                        variant='h4'
                        sx={{
                          fontWeight: 900,
                          color: '#fff',
                          letterSpacing: '-0.02em',
                          fontSize: { xs: '1.75rem', sm: '2.25rem' },
                          position: 'relative',
                          display: 'inline-block',
                          '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: -4,
                            left: 0,
                            width: '40%',
                            height: 4,
                            background: 'linear-gradient(90deg, #2196F3 0%, transparent 100%)',
                            borderRadius: 2,
                          },
                        }}
                      >
                        LinkedIn Analytics
                      </Typography>

             
                      <FormControl size='small' sx={{ minWidth: 160 }}>
                        <InputLabel sx={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '0.8rem' }}>
                          Filter by Month
                        </InputLabel>
                        <Select
                          value={selectedMonth}
                          label='Filter by Month'
                          onChange={handleMonthChange}
                          sx={{
                            color: '#fff',
                            height: 38,
                            background: 'rgba(255, 255, 255, 0.03)',
                            borderRadius: '10px',
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(255, 255, 255, 0.1)',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: alpha('#6871d1', 0.5),
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#6871d1',
                            },
                            '& .MuiSelect-icon': {
                              color: 'rgba(255, 255, 255, 0.5)',
                            },
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                background: '#1a1b26',
                                color: '#fff',
                                borderRadius: '12px',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                mt: 1,
                                '& .MuiMenuItem-root': {
                                  fontSize: '0.9rem',
                                  py: 1.5,
                                  '&:hover': {
                                    background: 'rgba(104, 113, 209, 0.1)',
                                  },
                                  '&.Mui-selected': {
                                    background: 'rgba(104, 113, 209, 0.2)',
                                    fontWeight: 600,
                                  },
                                },
                              },
                            },
                          }}
                        >
                          <MenuItem value='All'>All Months</MenuItem>
                          {availableMonths.map((month) => (
                            <MenuItem key={month} value={month}>
                              {month}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>

               
                    <Box
                      sx={{
                        mb: 4,
                        p: 1,
                        borderRadius: 3,
                      }}
                    >
                      <LinkedInStatsChart data={linkedInStats} selectedMonth={selectedMonth} />
                    </Box>
                  </Box>
                );
              })()} */}

            {/* SECTION 3: User Management and Activity Overview */}
            {/* {(adminName === 'admin' || adminName === 'superadmin' || adminName === 'sales') && (
              <Box sx={{ width: '100%', mx: 'auto', borderRadius: 3 }}>
                <Typography
                  variant='h4'
                  sx={{
                    mb: 3,
                    fontWeight: 800,
                    color: '#fff',
                    textAlign: 'left',
                    letterSpacing: 1,
                    position: 'relative',
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      bottom: -8,
                      left: 0,
                      width: 60,
                      height: 3,
                      background: 'linear-gradient(135deg, #4CAF50 0%, #8BC34A 100%)',
                      borderRadius: 2,
                    },
                  }}
                >
                  User Management and Activity Overview
                </Typography>

       
                {isSuperAdmin && (
                  <Paper
                    elevation={0}
                    sx={{
                      width: '100%',
                      p: 3,
                      mb: 4,
                      background: 'linear-gradient(145deg, #2b2c3e 0%, #1e1f2e 100%)',
                      borderRadius: 3,
                      border: '1px solid rgba(104, 113, 209, 0.1)',
                      boxShadow: '0 4px 20px 0 rgba(0,0,0,0.2)',
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <Avatar
                        sx={{
                          bgcolor: 'rgba(104, 113, 209, 0.2)',
                          color: '#6871d1',
                          mr: 2,
                          width: 40,
                          height: 40,
                        }}
                      >
                        <FilterList />
                      </Avatar>
                      <Box>
                        <Typography
                          variant='h6'
                          sx={{
                            fontWeight: 700,
                            color: '#fff',
                            lineHeight: 1.2,
                            letterSpacing: 0.5,
                          }}
                        >
                          Filter by User
                        </Typography>
                        <Typography variant='caption' sx={{ color: '#aaa' }}>
                          Select a user to view their specific stats
                        </Typography>
                      </Box>
                    </Box>

                    <FormControl fullWidth>
                      <InputLabel
                        id='user-select-label'
                        sx={{
                          color: '#aaa',
                          '&.Mui-focused': { color: '#6871d1' },
                        }}
                      >
                        Select User
                      </InputLabel>
                      <Select
                        labelId='user-select-label'
                        id='user-select'
                        value={selectedUser}
                        label='Select User'
                        onChange={handleUserChange}
                        startAdornment={<People sx={{ color: '#6871d1', mr: 1, ml: -0.5 }} />}
                        sx={{
                          background: 'rgba(255, 255, 255, 0.03)',
                          color: '#fff',
                          borderRadius: 2,
                          transition: 'all 0.2s',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(104, 113, 209, 0.3)',
                          },
                          '&:hover': {
                            background: 'rgba(255, 255, 255, 0.05)',
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#6871d1',
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#6871d1',
                            boxShadow: '0 0 0 4px rgba(104,113,209,0.1)',
                          },
                          '& .MuiSelect-icon': {
                            color: '#6871d1',
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              background: '#2b2c3e',
                              color: '#fff',
                              borderRadius: 2,
                              border: '1px solid rgba(104, 113, 209, 0.2)',
                              boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
                              '& .MuiMenuItem-root': {
                                '&:hover': {
                                  background: 'rgba(104, 113, 209, 0.1)',
                                },
                                '&.Mui-selected': {
                                  background: 'rgba(104, 113, 209, 0.2)',
                                  '&:hover': {
                                    background: 'rgba(104, 113, 209, 0.3)',
                                  },
                                },
                              },
                            },
                          },
                        }}
                      >
                        <MenuItem value=''>
                          <em>All Users</em>
                        </MenuItem>
                        {users.map((user) => (
                          <MenuItem key={user._id} value={user.username || user.email}>
                            {user.username || user.email}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

    
                    {selectedUser && (
                      <UserTimeInfo
                        user={
                          users.find((u) => (u.username || u.email) === selectedUser) || {
                            lastLogin: undefined,
                            lastLogout: undefined,
                            activeTime: undefined,
                            loginTimestamps: [],
                          }
                        }
                      />
                    )}
                  </Paper>
                )}

  
                {selectedUser &&
                  userStatsData.userDailyStats &&
                  userStatsData.userDailyStats.length > 0 && (
                    <Box
                      sx={{
                        mb: 4,
                        mt: 2,
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <TrendingUp sx={{ color: '#6871d1', mr: 2, fontSize: 32 }} />
                        <Typography
                          variant='h5'
                          sx={{
                            fontWeight: 700,
                            color: '#fff',
                            letterSpacing: 0.5,
                          }}
                        >
                          Activity Timeline:{' '}
                          <span style={{ color: '#6871d1' }}>{selectedUser}</span>
                        </Typography>
                      </Box>

                      <Grid container spacing={3} alignItems='stretch'>
                        {userStatsData.userDailyStats[0].dailyStats.map(
                          (dailyStat: DailyStat, index: number) => {
                            const hasActivity =
                              dailyStat.contactsCreated > 0 ||
                              dailyStat.connectionsSent > 0 ||
                              dailyStat.followUpsCreated > 0 ||
                              dailyStat.followUpsCompleted > 0;

                            if (!hasActivity) return null;

                            return (
                              <Grid item xs={12} sm={6} md={3} key={index}>
                                <Paper
                                  elevation={0}
                                  sx={{
                                    p: 0,
                                    height: '100%',
                                    background: '#2b2c3e',
                                    borderRadius: 3,
                                    border: '1px solid rgba(104,113,209,0.1)',
                                    overflow: 'hidden',
                                    transition: 'all 0.3s cubic-bezier(.4,2,.6,1)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    '&:hover': {
                                      transform: 'translateY(-8px)',
                                      boxShadow: '0 12px 30px rgba(104,113,209,0.15)',
                                      borderColor: '#6871d1',
                                      '& .card-header': {
                                        background: '#6871d1',
                                      },
                                      '& .date-text': {
                                        color: 'white',
                                      },
                                    },
                                  }}
                                >
       
                                  <Box
                                    className='card-header'
                                    sx={{
                                      p: 2,
                                      background: 'rgba(104,113,209,0.1)',
                                      transition: 'background 0.3s',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      borderBottom: '1px solid rgba(104,113,209,0.1)',
                                    }}
                                  >
                                    <CalendarToday
                                      className='date-text'
                                      sx={{
                                        fontSize: 18,
                                        mr: 1,
                                        color: '#6871d1',
                                        transition: 'color 0.3s',
                                      }}
                                    />
                                    <Typography
                                      className='date-text'
                                      variant='h6'
                                      sx={{
                                        fontWeight: 700,
                                        color: '#6871d1',
                                        fontSize: '1.1rem',
                                        transition: 'color 0.3s',
                                      }}
                                    >
                                      {new Date(dailyStat.date).toLocaleDateString(undefined, {
                                        weekday: 'short',
                                        month: 'short',
                                        day: 'numeric',
                                      })}
                                    </Typography>
                                  </Box>

                   
                                  <Box sx={{ p: 2.5, flexGrow: 1 }}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12}>
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            mb: 1.5,
                                          }}
                                        >
                                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Avatar
                                              sx={{
                                                width: 28,
                                                height: 28,
                                                bgcolor: 'rgba(33, 150, 243, 0.1)',
                                                color: '#2196F3',
                                                mr: 1.5,
                                              }}
                                            >
                                              <PersonAdd sx={{ fontSize: 16 }} />
                                            </Avatar>
                                            <Typography
                                              variant='body2'
                                              sx={{ color: '#ccc', fontSize: '0.9rem' }}
                                            >
                                              Created
                                            </Typography>
                                          </Box>
                                          <Typography
                                            variant='body1'
                                            sx={{ color: '#fff', fontWeight: 600 }}
                                          >
                                            {dailyStat.contactsCreated}
                                          </Typography>
                                        </Box>

                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            mb: 1.5,
                                          }}
                                        >
                                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Avatar
                                              sx={{
                                                width: 28,
                                                height: 28,
                                                bgcolor: 'rgba(156, 39, 176, 0.1)',
                                                color: '#9C27B0',
                                                mr: 1.5,
                                              }}
                                            >
                                              <Send sx={{ fontSize: 16 }} />
                                            </Avatar>
                                            <Typography
                                              variant='body2'
                                              sx={{ color: '#ccc', fontSize: '0.9rem' }}
                                            >
                                              Sent
                                            </Typography>
                                          </Box>
                                          <Typography
                                            variant='body1'
                                            sx={{ color: '#fff', fontWeight: 600 }}
                                          >
                                            {dailyStat.connectionsSent}
                                          </Typography>
                                        </Box>

                                        <Divider
                                          sx={{ my: 1.5, borderColor: 'rgba(255,255,255,0.05)' }}
                                        />

                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            mb: 1.5,
                                          }}
                                        >
                                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Avatar
                                              sx={{
                                                width: 28,
                                                height: 28,
                                                bgcolor: 'rgba(255, 152, 0, 0.1)',
                                                color: '#FF9800',
                                                mr: 1.5,
                                              }}
                                            >
                                              <PostAdd sx={{ fontSize: 16 }} />
                                            </Avatar>
                                            <Typography
                                              variant='body2'
                                              sx={{ color: '#ccc', fontSize: '0.9rem' }}
                                            >
                                              Follow-ups
                                            </Typography>
                                          </Box>
                                          <Typography
                                            variant='body1'
                                            sx={{ color: '#fff', fontWeight: 600 }}
                                          >
                                            {dailyStat.followUpsCreated}
                                          </Typography>
                                        </Box>

                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                          }}
                                        >
                                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Avatar
                                              sx={{
                                                width: 28,
                                                height: 28,
                                                bgcolor: 'rgba(76, 175, 80, 0.1)',
                                                color: '#4CAF50',
                                                mr: 1.5,
                                              }}
                                            >
                                              <TaskAlt sx={{ fontSize: 16 }} />
                                            </Avatar>
                                            <Typography
                                              variant='body2'
                                              sx={{ color: '#ccc', fontSize: '0.9rem' }}
                                            >
                                              Completed
                                            </Typography>
                                          </Box>
                                          <Typography
                                            variant='body1'
                                            sx={{ color: '#fff', fontWeight: 600 }}
                                          >
                                            {dailyStat.followUpsCompleted}
                                          </Typography>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                </Paper>
                              </Grid>
                            );
                          }
                        )}
                      </Grid>
                    </Box>
                  )}


                <Box
                  sx={{
                    // background:
                    //   'linear-gradient(145deg, rgba(76, 175, 80, 0.05) 0%, rgba(139, 195, 74, 0.05) 100%)',
                    //borderRadius: 3,
                    //border: '1px solid rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    mt: 3,
                  }}
                >
                  <Typography
                    variant='h4'
                    sx={{
                      mb: 3,
                      fontWeight: 800,
                      color: '#fff',
                      textAlign: 'left',
                      letterSpacing: 1,
                      position: 'relative',
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: -8,
                        left: 0,
                        width: 60,
                        height: 3,
                        background: 'linear-gradient(135deg, #4CAF50 0%, #8BC34A 100%)',
                        borderRadius: 2,
                      },
                    }}
                  >
                    Performance Analytics
                  </Typography>
                  <BarGraph
                    data={userStatsData.dailyTotals}
                    period={period}
                    onPeriodChange={handlePeriodChange}
                    userDailyStats={userStatsData.userDailyStats}
                    selectedUser={selectedUser}
                  />
                </Box>
              </Box>
            )} */}
          </>
        )}

        {/* LinkedIn Stats Form Popup */}
        {showLinkedInForm && (
          <LinkedInStatsForm
            open={showLinkedInForm}
            onClose={() => {
              console.log('Form close triggered');
              setShowLinkedInForm(false);
            }}
            weekStartDate={previousWeekData?.weekStartDate || ''}
            weekEndDate={previousWeekData?.weekEndDate || ''}
            onSuccess={() => {
              console.log('Form onSuccess prop called');
              handleLinkedInFormSuccess();
            }}
            onError={(message: string) => {
              setNotification({
                open: true,
                message: message,
                severity: 'error',
              });
            }}
          />
        )}

        {/* Analytics Form Popup */}
        {showAnalyticsForm && (
          <AnalyticsForm
            open={showAnalyticsForm}
            onClose={() => setShowAnalyticsForm(false)}
            onSuccess={handleAnalyticsFormSuccess}
            onError={(message: string) => {
              setNotification({
                open: true,
                message: message,
                severity: 'error',
              });
            }}
          />
        )}

        {/* Notification Snackbar */}
        <Snackbar
          open={notification.open}
          autoHideDuration={4000}
          onClose={handleNotificationClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert
            onClose={handleNotificationClose}
            severity={notification.severity}
            sx={{ width: '100%' }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      </Box>
    </Page>
  );
}
